





















export default {
  name: 'InstagramWidget',
  props: {
    hideTexts: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    list () {
      return [...Array(this.$t('TryItNow.InstagramWidget.List').length)].map((_, index) => this.$t(`TryItNow.InstagramWidget.List[${index}]`))
    }
  },
  head () {
    return {
      script: [
        // { src: 'https://apps.elfsight.com/p/platform.js', defer: true }
      ]
    }
  }
}
